// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { CrawlerTypeSchema } from '../inputTypeSchemas/CrawlerTypeSchema'
import { CrawlerSessionStatusSchema } from '../inputTypeSchemas/CrawlerSessionStatusSchema'

/////////////////////////////////////////
// CRAWLER SESSION SCHEMA
/////////////////////////////////////////

export const CrawlerSessionSchema = z.object({
  crawlerType: CrawlerTypeSchema,
  status: CrawlerSessionStatusSchema,
  id: z.string(),
  tenantId: z.string().nullable(),
  userId: z.string().nullable(),
  applicationId: z.string(),
  credentialId: z.string().nullable(),
  parentId: z.string().nullable(),
  finishedAt: z.coerce.date().nullable(),
  error: z.string().nullable(),
  lastHeartbeatAt: z.coerce.date(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type CrawlerSession = z.infer<typeof CrawlerSessionSchema>

export default CrawlerSessionSchema;
